/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MovimentoEntrUsc from './MovimentoEntrUsc';

class EntrateUsciteFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            letters: ['All','E','U'],
            selected: props.letter,
        };
        this.onClick = this.onClick.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if (this.state.selected !== nextProps.letter)
        {
            this.setState({selected: nextProps.letter});
        }
    }

    onClick(letter) {
        this.setState({ selected: letter })
        this.props.onChange(letter);
    }

    render() {
        return (
            <div>
                {this.state.letters.map((letter) => (
                    letter === this.state.selected ?
                        <button key={letter} className="ui basic secondary disabled  button" ><MovimentoEntrUsc tipo={letter} showLabel="true" otherLabel="All" /></button>
                        :
                        <button key={letter}  className="ui basic primary  button"  onClick={(ev) => this.onClick(letter)}><MovimentoEntrUsc tipo={letter} showLabel="true" otherLabel="All" /></button>

                ))}

            </div>
        )
    }
}

EntrateUsciteFilter.PropTypes = {
    letter: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

EntrateUsciteFilter.defaultProps = {
    letter: 'All'
};
export default EntrateUsciteFilter;



/** WEBPACK FOOTER **
 ** ./src/components/movimenti/EntrateUsciteFilter.js
 **/